<!--
  AI:
  Status: "in progress"
  Type: Component
  SubType: Template
  Reason: Read-only display of internal typed xx.XxPersonData rows for a selected
          XxPersonType, with columns derived from the row keys (core fields +
          gen_<typeFieldId> generic-attribute values) (TM-1000001960).
-->
@if (initialized) {
    <div class="flex flex-column gap-3">

        <!-- Type selector -->
        <p-panel header="Personentyp">
            <div class="flex align-items-center gap-2">
                <label for="xx-person-data-type" class="font-medium">Personentyp</label>
                <p-select
                        inputId="xx-person-data-type"
                        [options]="personTypes"
                        [(ngModel)]="selectedType"
                        (onChange)="onTypeSelect()"
                        [showClear]="true"
                        placeholder="Personentyp auswählen"
                        appendTo="body"
                        styleClass="w-20rem">
                    <ng-template let-type pTemplate="selectedItem">
                        @if (type) {
                            <span>{{ resolveTypeLabel(type) }}</span>
                        }
                    </ng-template>
                    <ng-template let-type pTemplate="item">
                        <span>{{ resolveTypeLabel(type) }}</span>
                    </ng-template>
                </p-select>
            </div>
        </p-panel>

        <!-- Error state -->
        @if (errorMessage) {
            <p-message severity="error" [text]="errorMessage" styleClass="w-full"></p-message>
        }

        <!-- Loading state -->
        @if (loading) {
            <div class="flex justify-content-center align-items-center p-5 gap-2">
                <p-progressSpinner styleClass="w-3rem h-3rem" strokeWidth="4"></p-progressSpinner>
                <span class="text-color-secondary">Daten werden geladen…</span>
            </div>
        }

        <!-- Result section -->
        @if (!loading && selectedType && !errorMessage) {
            <p-panel [header]="sectionTitle">

                @if (rows.length === 0) {
                    <p-message
                            severity="info"
                            text="Keine internen typisierten Personendaten für diesen Personentyp gefunden."
                            styleClass="w-full"></p-message>
                } @else {
                    <p-table [value]="rows" [scrollable]="true" styleClass="p-datatable-sm">
                        <ng-template pTemplate="header">
                            <tr>
                                @for (col of columns; track col.key) {
                                    <th>{{ col.header }}</th>
                                }
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-row>
                            <tr>
                                @for (col of columns; track col.key) {
                                    <td>{{ displayValue(row, col.key) }}</td>
                                }
                            </tr>
                        </ng-template>
                    </p-table>
                }
            </p-panel>
        }

        <!-- Initial empty / no-selection hint -->
        @if (!loading && !selectedType && !errorMessage) {
            <p-message
                    severity="info"
                    text="Bitte oben einen Personentyp auswählen, um die internen typisierten Daten anzuzeigen."
                    styleClass="w-full"></p-message>
        }
    </div>
}
